import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import EntryPage from './pages/EntryPage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import HomePage from './pages/HomePage';
import AdminPage from './pages/AdminPage';
// import { playThunderSound } from './utils/soundEffects';
import './App.css';

function App() {
  

  return (
    <div className="App">
      <Routes>
        <Route path="/entry" element={<EntryPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/" element={<HomePage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="*" element={<Navigate to="/entry" />} />
      </Routes>
    </div>
  );
}

export default App;